import React from 'react';
export const UserVerification = ({ user }) => {
    return user?.emailVerified ? null : (React.createElement("div", { className: "u-margin-bottom-large" },
        React.createElement("span", { className: "g-error" }, "You've been sent a verification email. Before you can access your account you need to verify your email address. Please check your inbox or click \"Resend Verification Email\" to resend")));
};
